import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  Platform,
  ViewController,
} from "ionic-angular";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-legal-fannel-info",
  templateUrl: "legal-fannel-info.html",
})
export class LegalFannelInfoPage {
  ios: boolean;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private platform: Platform,
    private configService: ConfigService,
    public viewCtrl: ViewController
  ) {
    if (this.platform.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }

    this.ios = false;
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad LegalFannelInfoPage");
  }

  ionViewWillEnter() {}
}



// WEBPACK FOOTER //
// ./src/pages/legal-fannel-info/legal-fannel-info.ts